<div *ngIf="statusLabel" class="estimate-status-wrapper">
  <span class="estimate-status">
    {{ statusLabel }}
  </span>

  <app-icon *ngIf="icon" [icon]="icon" class="estimate-status-icon"> </app-icon>
</div>
